import * as React from 'react';
import { Copy } from 'lucide-react';
import { toast } from 'sonner';

import { copyToClipboard } from '@klareospace/pharos-lib-front-utils';

import { Button, Input } from '../../ui';

// ─── Types ────────────────────────────────────────────────────────────────────

export interface CopyableFieldProps {
  copiedLabel: string;
  copyFailedLabel: string;
  label: string;
  value: string;
}

// ─── Component ────────────────────────────────────────────────────────────────

/**
 * Read-only field with a label and a copy-to-clipboard button.
 * i18n-agnostic — pass already-translated strings for `copiedLabel` and `copyFailedLabel`.
 */
export function CopyableField({ copiedLabel, copyFailedLabel, label, value }: CopyableFieldProps): React.JSX.Element {
  function handleCopy(): void {
    void copyToClipboard(value).then((success) => {
      if (success) {
        toast.success(copiedLabel);
      } else {
        toast.error(copyFailedLabel);
      }
    });
  }

  return (
    <div className="space-y-1.5">
      <p className="text-sm font-medium text-foreground">{label}</p>
      <div className="flex items-center gap-2">
        <Input className="font-mono text-xs" readOnly value={value} />
        <Button onClick={handleCopy} size="icon" type="button" variant="outline">
          <Copy className="h-4 w-4" />
        </Button>
      </div>
    </div>
  );
}
